import { NgClass, UpperCasePipe } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'iot-platform-ui-placeholder-card',
  imports: [TranslatePipe, MatIcon, NgClass, UpperCasePipe],
  templateUrl: './placeholder-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./placeholder-card.component.scss']
})
export class PlaceholderCardComponent {
  text = input.required<string>();
  icon = input<string>();
  clickable = input<boolean>(false);
  disabled = input<boolean>(false);
}
